// import targetUrl from "../../images/target_test.jpg";

const targetDefault = {
  loading: false,
  url: null,
  // url: targetUrl,
  sourceUrl: null,
  name: "",
  aspectRatio: null,
  x: null,
  y: null,
  w: null,
  h: null,
  cropMode: false,
  cropRegion: null,
  exifOrientation: null,
  cropOrientation: "",
  ready: false
};
const target = (state = targetDefault, action) => {
  switch (action.type) {
    case "SET_MOSAIC_TARGET":
      return { ...targetDefault, loading: true };
    case "SET_MOSAIC_TARGET_SUCCESS": {
      return {
        ...state,
        loading: false,
        url: action.url,
        w: action.w,
        h: action.h,
        x: action.x,
        y: action.y,
        name: action.name,
        exifOrientation: action.exifOrientation,
        aspectRatio: action.aspectRatio,
        ready: true
      };
    }
    case "SET_MOSAIC_TARGET_FAILURE":
    case "CLEAR_MOSAIC_TARGET":
      return targetDefault;
    case "SET_MOSAIC_TARGET_SOURCEURL":
      return {
        ...state,
        sourceUrl: action.url
      };
    case "ENTER_MOSAIC_TARGET_CROP_MODE":
      return {
        ...state,
        cropMode: true,
        cropRegion: {
          x: state.x,
          y: state.y,
          w: state.w,
          h: state.h
        },
        cropOrientation: state.w >= state.h ? "landscape" : "portrait",
        sourceUrl: action.url
      };
    case "LEAVE_MOSAIC_TARGET_CROP_MODE":
      return {
        ...state,
        cropMode: false,
        sourceUrl: null,
        cropRegion: null,
        cropOrientation: ""
      };
    case "TOGGLE_MOSAIC_TARGET_CROP_ORIENTATION":
      return {
        ...state,
        cropOrientation:
          state.cropOrientation === "landscape" ? "portrait" : "landscape"
      };
    case "UPDATE_MOSAIC_TARGET_CROP_REGION":
      return { ...state, cropRegion: action.region };
    case "CROP_MOSAIC_TARGET":
      return {
        ...state,
        cropMode: false,
        loading: true,
        sourceUrl: null,
        cropOrientation: ""
      };
    case "CROP_MOSAIC_TARGET_SUCCESS": {
      const { url, w, h, x, y } = action;
      return {
        ...state,
        loading: false,
        url,
        w,
        h,
        x,
        y,
        cropRegion: null,
        aspectRatio: action.aspectRatio
      };
    }
    case "CROP_MOSAIC_TARGET_FAILURE":
      return { ...state, loading: false, cropRegion: null };
    default:
      return state;
  }
};
export default target;



// WEBPACK FOOTER //
// ./src/reducers/mosaic/target.js